"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _styles = require("@material-ui/core/styles");

var Checkbox =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Checkbox, _React$PureComponent);

  function Checkbox() {
    (0, _classCallCheck2.default)(this, Checkbox);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Checkbox).apply(this, arguments));
  }

  (0, _createClass2.default)(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          color = _this$props.color,
          disabled = _this$props.disabled,
          indeterminate = _this$props.indeterminate,
          label = _this$props.label,
          labelPlacement = _this$props.labelPlacement,
          _onChange = _this$props.onChange,
          value = _this$props.value,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["checked", "color", "disabled", "indeterminate", "label", "labelPlacement", "onChange", "value"]);

      var _checkbox = _react.default.createElement(_Checkbox.default, (0, _extends2.default)({}, props, {
        checked: checked,
        disabled: disabled,
        color: color,
        indeterminate: indeterminate,
        onChange: function onChange(e) {
          return _onChange(e, event.target.checked);
        },
        value: value || ''
      }));

      return label ? _react.default.createElement(_FormControlLabel.default, {
        control: _checkbox,
        label: _react.default.createElement("div", {
          style: {
            paddingTop: '2.5px'
          }
        }, typeof label === 'string' ? _react.default.createElement(_Typography.default, {
          variant: 'body1'
        }, label) : label),
        labelPlacement: labelPlacement
      }) : _checkbox;
    }
  }]);
  return Checkbox;
}(_react.default.PureComponent);

Checkbox.defaultProps = {
  color: 'primary',
  disabled: false,
  indeterminate: false,
  label: null,
  labelPlacement: 'end',
  value: null
};
Checkbox.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]).isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes.default.node,

  /**
   * The position of the label.
   */
  labelPlacement: _propTypes.default.oneOf(['end', 'start', 'top', 'bottom']),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
};
var _default = Checkbox;
exports.default = _default;